export class KladrItem {
    public readonly title: string;
    public readonly code: string;

    constructor(dto?: IKladrItemDto) {
        this.title = dto?.title || "";
        this.code = dto?.code || "";
    }
}

export interface IKladrItemDto {
    readonly code?: string;
    readonly title?: string;
}
